
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gaza-response",
      function () {
        return require("private-next-pages/gaza-response.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gaza-response"])
      });
    }
  